import { effectivePermissionSetHas } from '@utazzo/shared';

import { useMyEffectivePermissions } from '@/features/my-profile/use-my-profile';

/**
 * Whether this user can answer WhatsApp calls in Utazzo - the same rule the
 * softphone and the accept endpoint use (`ops.whatsapp.write`).
 */
export const useCanTakeWhatsAppCalls = (): boolean =>
  effectivePermissionSetHas(useMyEffectivePermissions(), 'ops.whatsapp.write');
